import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import styled, { createGlobalStyle } from 'styled-components'
import { TextLink } from '@/components/button'
import ContentWrapper from '@/components/content-wrapper'
import Page from '@/components/page'
import PageTitle from '@/components/page-title'
import TenantSummary from '@/features/Profile/TenantSummary'
import useProfile from '@/hooks/use-profile'
import { breakpoints, colors, structure, shadows } from '@/styles'
import { ProfileIcon } from '@/components/icons'
import DashboardItems from './dashboard-items'

const MainWrapper = styled(ContentWrapper)`
  margin-top: 50px;
  margin-bottom: 50px;
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    margin: 0;
    max-width: none;
  }
`

const MobileBackground = createGlobalStyle`
  body {
    @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
      background: ${colors.white};
    }
  }
`

const AccountInfo = styled.div`
  position: sticky;
  background: ${colors.white};
  box-shadow: ${shadows.header};
  z-index: 2;
  max-height: 215px;
  overflow: hidden;
  top: ${structure.header.height}px;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    width: 100%;
    top: ${structure.header.heightMobile}px;
  }
`

const ProfileLink = styled(TextLink)`
  margin-top: 0;
  padding: 5px 0;
`

const Dashboard = () => {
  const { t } = useTranslation()
  const data = useProfile()
  const completedProfile = data.completion_percentage === 100
  const profileTitle = t('l.profile.view.my_profile.title', 'Profile')
  const viewProfile = t('l.settings.view.view_profile.button', 'View profile')
  return (
    <>
      <Helmet>
        <title>{profileTitle}</title>
      </Helmet>
      <PageTitle />
      <MobileBackground />
      <PageTitle>
        <ProfileIcon /> {profileTitle}
      </PageTitle>
      <Page>
        <AccountInfo>
          <TenantSummary data={data} editable isHeader>
            <ProfileLink to="/profile/basic-info">{viewProfile}</ProfileLink>
          </TenantSummary>
        </AccountInfo>
        <MainWrapper>
          <DashboardItems completedProfile={completedProfile} />
        </MainWrapper>
      </Page>
    </>
  )
}

export default Dashboard
